import {axiosClient} from "@/main";
import handleResponse from "@/services/handleResponse";

export interface UserProfile {
  isApprover: boolean,
  isAdmin?: boolean,
  optOut: boolean
}

export interface User {
  firstName: string,
  lastName: string,
  email: string,
  gid: string,
  profile: UserProfile,
  country: string,
  org_code: string
}

export const isUserAnonymous = (user: User) => user.gid === "anonymous";

export const searchUsers = async (data: { mail: string, firstName: string, lastName: string }): Promise<User[]> => {
  const q = Object.fromEntries(
    Object.entries(data).filter(([_, value]) => value != "")
  );
  const response = await handleResponse(
    axiosClient.post(`/backend/user/query`, {q})
  )

  const result = response as User[];

  result.forEach(it => {
    if (it.profile.optOut === undefined) it.profile.optOut = false;
    if (it.profile.isApprover === undefined) it.profile.isApprover = false;
    if (it.profile.isAdmin === undefined) it.profile.isAdmin = false;
  })

  return result
}

export const getCurrentUser = async (): Promise<User> => {
  const response = await handleResponse(axiosClient.get(`/backend/user`));

  const result = response as User

  if (result.profile.optOut === undefined) result.profile.optOut = false;
  if (result.profile.isApprover === undefined) result.profile.isApprover = false;
  if (result.profile.isAdmin === undefined) result.profile.isAdmin = false;

  return result;
}

export const setOptOut = async (value: boolean): Promise<void> => handleResponse(
  axiosClient.post(`/backend/user/optOut`, {optOut: value})
)

